import React from 'react'
import PropTypes from 'prop-types'

const WarningIcon = ({ dataTestId, className }) => {
  return (
    <svg
      className={className}
      data-testid={dataTestId}
      height="70"
      viewBox="0 0 70 70"
      width="70"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(-349 -334)">
          <g transform="translate(147 260)">
            <g transform="translate(202 74)">
              <circle cx="35" cy="35" fill="#F3544C" r="35" />
              <g transform="translate(32 18)">
                <g>
                  <path
                    d="M3.5 0L3.5 23.815"
                    stroke="#FFF"
                    strokeLinecap="round"
                    strokeWidth="7"
                  />
                  <circle cx="3.5" cy="35.5" fill="#FFF" r="3.5" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

WarningIcon.propTypes = {
  className: PropTypes.string,
  dataTestId: PropTypes.string.isRequired,
}
export default WarningIcon



// WEBPACK FOOTER //
// ./src/components/WarningIcon/component.jsx